export const status = [{ value: 'ACTIVE' }, { value: 'INACTIVE' }];
export const activeStatus = 'ACTIVE';
